import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';
import debounce from 'lodash/debounce.js';

injector.injectClass(class extends Script {
    onLoad() {
        $('[data-catalog]').each(this.$wrap(this.initCatalog));
    }

    initCatalog($container) {
        const name = $container.data('catalog');
        const url = $container.data('url');

        const $main = $container.children().first();
        const $search = $('<div>').hide().appendTo($container);

        // search
        if ($container.data('search')) {
            const $input = $(`${$container.data('search')} input`);
            const $button = $(`${$container.data('search')} button`);

            const doSearch = () => {
                const value = $input.val().trim();
                if (value) {
                    $main.hide();
                    $search.empty().append('<div class="loading">');
                    $.get(url, { search: value }).then((res) => {
                        $search.html(res);
                    }).always(() => {
                        $search.find('.loading').remove();
                    });
                    $search.show();
                }
                else {
                    $search.empty().hide();
                    $main.show();
                }
            };

            $input.on('input paste keyup', debounce(doSearch, 500));
            $button.on('click', () => doSearch(true));
        }

        // expand/collapse
        $container.on('click', '[data-children]', this.$wrap(($item) => {
            const $button = $item.find('button.expand-list');
            $button.html($button.html() === '+' ? '-' : '+');
            $item.next('.inner').toggle();
            this.saveExpand(name);
        }));

        // restore expand state
        const data = localStorage.getItem(`catalog-expand-${name}`);
        if (data) {
            data.split(',').forEach((sid) => {
                const $item = $container.find(`article[data-sid=${sid}][data-children]`);
                if ($item.length) {
                    $item.find('button.expand-list').html('-');
                    $item.next('.inner').show();
                }
            });
        }
    }

    saveExpand(name) {
        const sids = $('.inner:visible').map(function () {
            return $(this).prev('[data-children]').data('sid');
        }).get().filter(Boolean);

        localStorage.setItem(`catalog-expand-${name}`, sids.join(','));
    }
}, ['grammar', 'expressions']);
